import SegmentedChartsReports from '@/pages/reports/SegmentedChartsReports'
import SegmentedTextualReports from '@/pages/reports/SegmentedTextualReports'
import QuizReports from '@/pages/reports/QuizReports'

const routes = [
  {
    path: '/segmented-charts-reports',
    name: 'SegmentedChartsReports',
    component: SegmentedChartsReports,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_PARTNER', 'ROLE_ADMIN']
    }
  },
  {
    path: '/segmented-textual-reports',
    name: 'SegmentedTextualReports',
    component: SegmentedTextualReports,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_PARTNER', 'ROLE_ADMIN']
    }
  },
  {
    path: '/quiz-reports',
    name: 'QuizReports',
    component: QuizReports,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_PARK', 'ROLE_PARTNER']
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/reports.js